import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { State } from "../../../redux/slices";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { logoutGrainTrackerE } from "../../../redux/slices/grainTracker/grainTrackerEdition";
import { MenuEditLocation } from "../../userLocations/editLocation/EditLocation";
import { GrainTrackerStock } from "./GrainTrackerStockEdition";
import {
  deleteBin,
  updateBin,
} from "../../../redux/actions/GrainWise/grainwiseEditionServices/grainTrackerEdition";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    resetEditLocationValues: () => {
      dispatch(logoutGrainTrackerE());
    },

    deleteBin: (token: string) => {
      dispatch(deleteBin(token));
    },

    updateBin: (token: string) => {
      dispatch(updateBin(token));
    },
  };
};

const EditGrainTrackerBins: FC<any> = () => {
  const [t] = useTranslation("global");
  const { resetEditLocationValues } = SetActions();
  const { locationSelectedIs, selectedLocation } = useSelector(
    (state: State) => state.GrainWiseEditionReducer,
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (!selectedLocation.values.id) {
      navigate("/locations");
    }
  }, []);

  return (
    <div className="create-sites-container">
      {MenuEditLocation(
        locationSelectedIs.EditingValues,
        locationSelectedIs.EditingStockage,
        t,
        navigate,
        resetEditLocationValues,
        selectedLocation,
      )}

      {locationSelectedIs.EditingStockage ? <GrainTrackerStock /> : ""}
    </div>
  );
};

export default EditGrainTrackerBins;
